import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import TableHeader from "../../../../components/Tables/TableHeader";
import { Table_Array } from "../../arrays/RegistersFields";
import { Link } from "react-router-dom";
import { RegistersFields } from "../../arrays/RegistersFields";
import { Delete_One_From_MongoDB } from "../../../../api/Delete_One_From_MongoDB";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import { SendToDukes } from "../api/SendToDukes";

function TableOfViewRegisters({ Registers }) {
  const { logout } = StaffuseAuth();

  //----------------------------------Nested Sorting--------------------------------------------
  // State to track sort field and direction
  const [sortConfig, setSortConfig] = useState({
    field: null,
    direction: "ascending",
  });

  const sortedRegisters = React.useMemo(() => {
    let sortableItems = [...Registers];

    if (sortConfig.field === "_id") {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.field] < b[sortConfig.field]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.field] > b[sortConfig.field]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    } else if (sortConfig.field !== null) {
      sortableItems.sort((a, b) => {
        const aValue = a.BasicInfo?.[sortConfig.field] ?? "";
        const bValue = b.BasicInfo?.[sortConfig.field] ?? "";
        if (aValue.toLowerCase() < bValue.toLowerCase()) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue.toLowerCase() > bValue.toLowerCase()) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [Registers, sortConfig]);

  const requestSort = (field) => {
    let direction = "ascending";
    if (sortConfig.field === field && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ field, direction });
  };

  function handleButtonClick(event, register) {
    // Handle the button click for the specific register
    console.log("Button clicked for register:", register);
    SendToDukes(
      register,
      logout
    )
  }

const [ Status, setStatus] = useState(false);
   function handleDeleteButtonClick(event, register) {
    // Handle the button click for the specific register
    console.log("Button clicked for register:", register);
    Delete_One_From_MongoDB(
  register._id,
  "Registers_2025",
  "All",
  setStatus,
  {},
  logout
)
  }
  

  //-----------------------------Return---------------------------------------------

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        View Register
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              <>{TableHeader("_id", requestSort, "_id")}</>
              <>{TableHeader("Created At", requestSort, "Created_At")}</>
              <>
                {TableHeader(
                  "OriginalOrderNumber At",
                  requestSort,
                  "OriginalOrderNumber"
                )}
              </>

              <>{TableHeader("First Name", requestSort, "First_Name")}</>
              <>{TableHeader("Last Name", requestSort, "Last_Name")}</>
              <>
                {TableHeader("ProgrammeTitle", requestSort, "ProgrammeTitle")}
              </>
              <>{TableHeader("ProgrammeDate", requestSort, "ProgrammeDate")}</>
              <>
                {TableHeader(
                  "ProgrammeVarient",
                  requestSort,
                  "ProgrammeVarient"
                )}
              </>
              <>{TableHeader("View", requestSort, "First_Name")}</>
              <>{TableHeader("SEF", requestSort, "First_Name")}</>

              <></>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRegisters.map((Register, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor:
                    Register?.MetaData?.Archived === "Yes"
                      ? "rgba(139, 0, 0, 0.5)"
                      : Register?.MetaData?.Reserved === "Yes"
                      ? "rgba(0, 0, 139, 0.5)"
                      : Register?.MetaData?.Bursary === "Yes"
                      ? "rgba(144, 238, 144, 0.5)"
                      : "",
                  "&:hover": {
                    backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word", // Adjust padding here to make cells smaller
                    },
                  },
                }}
              >
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register._id}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.Created_At
                      ? Register.BasicInfo.Created_At
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.OrderInfo &&
                    Register.OrderInfo.OriginalOrderNumber
                      ? Register.OrderInfo.OriginalOrderNumber
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.First_Name
                      ? Register.BasicInfo.First_Name
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.Last_Name
                      ? Register.BasicInfo.Last_Name
                      : ""}
                  </TableCell>
                </>

                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeTitle
                      ? Register.BasicInfo.ProgrammeTitle
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeDate
                      ? Register.BasicInfo.ProgrammeDate
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeVarient
                      ? Register.BasicInfo.ProgrammeVarient
                      : ""}
                  </TableCell>
                </>
                {/* New TableCell for update action using Link */}
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Link
                    to={`/Staff/ViewAttendee/${Register._id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button>View</button>
                  </Link>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {Register.BasicInfo?.ProgrammeTitle &&
                  Register.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
                    "summer"
                  ) ? (
                    <>
                      <Link
                        to={`/Staff/ViewSEFReview/${Register._id}`}
                        target="_blank"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <button>
                          SEF{" "}
                          {Register.SEFInfo?.SEF
                            ? Register.SEFInfo?.SEF.replaceAll("_", " ")
                            : "Not Started"}
                        </button>
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </TableCell>
                {/* <TableCell>
                  <button onClick={(e) => handleDeleteButtonClick(e, Register)}>handle</button>
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TableOfViewRegisters;
